import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import WhyUs from "@/components/site/WhyUs";
import PreventivoWizard from "@/components/site/PreventivoWizard";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import SmoothScroll from "@/components/site/SmoothScroll";

export default function Home() {
  return (
    <SmoothScroll>
      <main
        data-testid="home-page"
        className="relative min-h-screen bg-[#050505] text-white font-body"
      >
        <Header />
        <Hero />
        <Marquee />
        <About />
        <Services />
        <WhyUs />
        <PreventivoWizard />
        <Contact />
        <Footer />
        <WhatsAppFloat />
      </main>
    </SmoothScroll>
  );
}
